import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { BlogSection } from '../components/BlogSection';
export function BlogPage() {
  return <>
      <PageHeader title="Our Blog" backgroundImage="https://images.unsplash.com/photo-1457369804613-52c61a468e7d?auto=format&fit=crop&w=1920&q=80" data-id="element-730" />
      <BlogSection data-id="element-731" />
    </>;
}